// The physical office address for in-person bookings (audit C4,
// 2026-08-25). Single source so the calendar invite, the confirmation
// email/screen copy, the .ics/Google/Outlook links, and the public
// booking pages' footer never drift from each other.
export const OFFICE_ADDRESS = "1094 S Gilbert Rd Suite 210, Gilbert, AZ 85296";
